import Khoj from "./Events/Khoj.png";
import BlindCoding from "./Events/BlindCoding.png";
import FlyHigh from "./Events/FlyHigh.png";
import SpaceExpo from "./Events/SpaceExpo.png";
import RoboRace from "./Events/RoboRace.png";
import RelayRacing from "./Events/RelayRacing.png";
import MurderMystery from "./Events/MurderMystery.png";
import ShotOnQuiz from "./Events/ShotOnQuiz.png";
import RoboSoccer from "./Events/RoboSoccer.png";
import DraicPlayground from "./Events/DraicPlayground.png";
import HopSites from "./Events/HopSites.png";
import CodeBuddies from "./Events/CodeBuddies.png";
import MaskedCoding from "./Events/MaskedCoding.png";
import Blogathon from "./Events/Blogathon.png";
import BotBusters from "./Events/BotBusters.png";
import CadCompetiton from "./Events/CadCompetiton.png";
import GamingZone from "./Events/GamingZone.png";
// import KeynoteSession from "./Events/KeynoteSession.png";
import ReadandType from "./Events/ReadandType.png";
import SpeedTypers from "./Events/SpeedTypers.png";
// import web3 from "./Events/Web3.png";
import SupercarShow from "./Events/SupercarShow.png";
import TremblingTower from "./Events/TremblingTower.png";
import Hackathon from "./Events/Hackathon.png";
import TreasureHunt from "./Events/TreasureHunt.png";
import SpinningRival from "./Events/SpinningRival.png";
import quiz from "./Events/quiz.png";

export const eventsData = [
 
  // {
  //   id: 1,
  //   image: Khoj,
  //   name: "Example EVenr",
  //   description:
  //     "Example Desciption",
  //   rules: [
  //     "An ideal team size would consist of a minimum of 2 and a maximum of 4 individuals.",
  //     "Individuals from diverse departments are eligible for participation within the team.",
  //     "Individuals who are enrolled in an Undergraduate Degree program are eligible to participate.",
  //     "Team participants must provide proof of their college affiliation.",
  //     "Competition will be held in 2 rounds, round 1(Preliminary/Elimination round) and round 2(Final round). Rounds will be held on 20 and 21 Feb respectively.",
  //     "Inter college formation of a team is allowed.",
  //     "The project concept or idea must be a unique and original creation, free from any potential violation of existing intellectual property rights.",
  //     "Each student is limited to participation in a single group, as per the established guidelines.",
  //     "It is expected that the presentation will be delivered within a ten-minute time frame, in adherence to the established guidelines. Teams will also be given 5 minutes additional slot to present their working prototype in front of judges, if any.",
  //     "Teams are respectfully requested to strictly comply with the designated time frame and to exhibit cooperative behavior.",
  //     "In accordance with established policy, registration fees will not be eligible for refunded under any circumstances.",
  //     "All team leaders are respectfully requested to complete the registration form by providing the necessary information.",
  //     "All the events will commence at the scheduled time; Punctuality will be appreciated.",
  //   ],
  //   prizes: ["1st Prize: ₹", "2nd Prize: ₹", "3rd Prize: ₹"],
  //   team: "2-4",
  //   fees: "₹100 per team",
  //   contactInfo: [
  //     "",
  //     "",
  //     "",
  //   ],
  //   location: "CT Department",
  //   date: "Will be announced son",
  //   note: [
  //     "Teams having a working model of their idea will be considered as a plus point by judging panel.",
  //     "If any kind of trolling, offending, or misbehaving seen by participants will not be tolerated.",
  //   ],
  //   link: "",
  // },
  {/*
  {
    id: 2,
    image: TreasureHunt,
    name: "TREASURE HUNT",
    description:
      "During a logical questions treasure hunt, participants will be given a series of clues or challenges that require logical thinking and problem-solving skills. These clues will be delivered through a variety of formats, such as puzzles, riddles, or logic games, and will require participants to use their critical thinking and reasoning abilities to solve them. As participants solve each clue, they will be led to the next one until they reach the final treasure.",
    rules: [
      "All teams must have at least 2 members and no more than 4 members. Prior Registraations must be given.",
      "Do not open and view the clues prior to the announcement that the hunt has started.",
      "Teams must stay together during the Treasure Hunt and are encouraged to work together to solve the clues and retrieve the points from each location. Teams are encouraged to bring along a notepad so that they can note the answer once they’ve solved the clues.",
      "Teams will be scored on the total value of the clues collected and the amount of time taken. Once all coins are collected teams must return to the finish in order to be counted as finished. Point values will be determined based on the difficulty of the clue.",
      "Teams may or may not use smartphones or mobile internet devices.",
      "The Treasure Hunt begins at 1:00 p.m.",
    ],
    prizes: ["EXICITING PRIZES AND REWARDS"],
    team: "Individual",
    fees: "Free",
    contactInfo: ["Vaishnavi Varkur : 8828090518"],
    location: "A WING",
    date: "21th FEB (Full Day)",
    note: [""],
    link: "https://docs.google.com/forms/d/e/1FAIpQLSehzAtg5Sy5C4B5WkVTeD5SGxLrq0fSKzqdSKLh2UvJQkRVnA/viewform",
  },
  {
    id: 3,
    image: SpinningRival,
    name: "SPINNING RIVAL",
    description:
      "two challengers go head-to-head in a 1v1 competition. The question to be attempted is randomly chose using “SPIN the WHEEL”. Coding question present on the Spin Wheel.",
    rules: [
      "At a time two participants should be present while spinning the wheel.",
      "When spinning wheel stops, it will indicate to a special coding problem.",
      "An indication will be provided to start solving the coding problem for the two rivals.",
      "The Winner will be decided with an appropriate coding answer provided 5.If both the rivals submitted an appropriate answer, minimum time will be considered as a factor for the results.",
    ],
    prizes: ["EXICITING PRIZES AND REWARDS"],
    team: "Individual",
    fees: "Free",
    contactInfo: [
      "Vedika Sangle : 9578907935",
      "Utkarsha Kesarkar : 7887440601",
    ],
    location: "A WING",
    date: "20th FEB",
    note: [""],
    link: "https://docs.google.com/forms/d/e/1FAIpQLSfW29NpK5FGba-846Sr2WpwXRkc5Aef3cX_60c-eCxobjH2Zg/viewform?usp=sf_link",
  },
  {
    id: 4,
    image: BlindCoding,
    name: "Blind Coding",
    description:
      "The 'Blind Coding' competition is a unique challenge that tests both coding proficiency and communication skills. Participants will compete in pairs, with one participant tasked with critically analyzing a problem statement and explaining it to their partner who will write the code without being able to see the screen. This event will be held in three rounds, each with its own level of difficulty and point value. Participants will have a maximum of three attempts to score the highest points, with their best score being considered for the final ranking.Not only will this competition showcase your coding abilities, but it will also test your problem-solving skills and your ability to think and communicate under pressure. This is a valuable opportunity to develop and demonstrate your programming knowledge, and to gain valuable experience in coding, communication and teamwork.",
    rules: [
      "Participants are allowed to participate in pair. (Solo or more than 2 students are not allowed).",
      "Inter college grouping for teams is allowed.",
      "Participants need to present on location with their partner to participate in the competition.",
      "PC's / laptops are provided to each participating team",
      "Two participants are seated opposite to each other ( One with keyboard who will not be able to see the monitor screen other with Laptop/monitor screen)",
      "Team member in front of keyboard is not allowed to see the screen",
      "Team member in front of monitor screen is not allowed to type anything on screen.",
      "Team members are allowed to communicate with each other during the problem solving",
      "Each team will be provided with max three chances to compete in competition.",
      "The teams are not allowed to change their partner during their next turns",
      "The level of questions are categorised as Easy, Medium and Hard with the points of 100, 250, 500 respectively",
      "The team has to first solve the Easy, Medium and then only Hard question i.e the previous level of question should be solved successfully before trying for other level of question",
    ],
    prizes: [
      "1st - Keyboard and mouse combo",
      "2nd - Laptop Bag",
      "3rd - Earphones",
    ],
    team: "2",
    fees: "Free",
    contactInfo: [
      "Pratik Patil : 9370438737",
      "Dnyanesh Bachhav : 9370735440",
      "Vishakha Gaurakar : 9158615935",
    ],
    location: "A Building Entrance",
    date: "20 Feb",
    note: "",
    link: "https://docs.google.com/forms/d/e/1FAIpQLSc3xZCzF8NQI0FVZExRSFJEVEuvDRDdV74qNu5tvhNrE4G6cw/viewform",
    onSpot: "",
  },
  {
    id: 5,
    image: FlyHigh,
    name: "FLY HIGH SHOW",
    description:
      "An Aerial Show in which an airplane and a drone will be deployed simultaneously in the sky, catching the attention of the people on ground. Below there will be a set from which all these will be launched and controlled. This area will also contain all the information about these projects including Where these are used, How it was made, Components required to make this, Description of components, Budget of the overall project and much more. This will act as a great impression for those who have keen interests in aeronautics and flying objects. Also this event will attract people from far and will add as a great addition to the event",
    rules: ["NA"],
    prizes: ["NA"],
    team: "Individual",
    fees: "Free",
    contactInfo: [
      "Shreyash Vikhare  : 9373742371",
      "Samyak Ghangale : 7499849658",
    ],
    location: "Center Lawn",
    date: "20th Feb (Opening Ceremony)",
    note: [],
    link: "",
  },
  {
    id: 6,
    image: RelayRacing,
    name: "Bot relay race",
    description:
      " A battle between students all around to compete with each other. Each team is typically made up of several robots, each of which is designed for relay races. The robots work together to push a circular 3d ball as a relay, till the end line with each robot completing its task and then passing the 'baton' to the next robot in the team.The goal of the race is for the team of robots to complete the course as quickly and efficiently as possible, with the winning team being the one that crosses the finish line first.",
    rules: [
      "The objective of the game",
      "During 5 minutes four robots of the same team shall drive the maximum number of laps with a relay baton passing it every time in the exchange zone.",
      "Start",
      "At the start all the robots should be in the exchange zone.",
      "When starting, the relay baton should be outside the line limiting the relay zone before the robot which starts to move along the black line first.",
      "After starting up the robot shall drive along the specified black line and when got back to the exchange zone pass the relay baton to the next robot.",
      "During competition the participants are not allowed to touch the robot body and the baton.",
      "Relay baton passing and loosing",
      "Relay baton passing is permitted only in the exchange zone.",
      "The robot which passed the relay baton shall stay in the exchange zone.",
      "Relay baton loosing can occur only outside the exchange zone.",
      "Game over",
      "Robot movement stops in the following situations:",
      "If the robot loses the relay baton.",
      "If the robot leaves the exchange zone without a relay baton.",
      "If the operator touches the robot body or the relay baton.",
      "If any robot loses the line for more than 5 seconds.",
      "If the robot which passed the relay baton leaves the exchange zone after the other robot receives the relay baton.",
      "Finish",
      "Attempt ends after the player puts the baton into the final goal or player exceeds the clock by 5 min.",
    ],
    prizes: ["NA"],
    team: "Team of 4 players will be made at the time or race or it can even be a premade group. Each of the participants will be provided with 1 bot at the time of race.",
    fees: "Rs 99 per team",
    contactInfo: [
      "Ashlesha Lamkhade : 7447577756",
      "Siddhesh Raut : 9420410175",
    ],
    location: "Lawn",
    date: "21st Feb 10:00am onwards",
    note: [""],
    link: "https://docs.google.com/forms/d/e/1FAIpQLScfe2rSolO-FC-q7puLr2ca9UL3o0xDW4UJViqqX5tmDwbrBQ/viewform",
  },
  {
    id: 7,
    image: MurderMystery,
    name: "Murder Mystery",
    description: [
      "Murder by a time traveler- A Murder Mystery",
      "In the year 2040, a group of college students at a prestigious university are participating in a time travel experiment.",
      "One of the students, John, suddenly disappears and is found dead in his lab, seemingly from a self-inflicted gunshot wound.",
      "Can the detective inside you debunk this mystery and recognize John’s killer?",
    ],
    rules: "",
    prizes: ["Exciting Prizes"],
    team: "Team of MAX 4 members.",
    fees: "Free",
    contactInfo: ["Akash Bharati : 9623986208"],
    location: "A wing Basement",
    date: "20st Feb 10:00am onwards, closes at 11:15am on 20th Feb",
    note: [
      "Registrations link will be available till only the 20th Feb 11:15am after this no registrations will be accepted",
    ],
    link: "https://tinyurl.com/mudermystery",
  },
  {
    id: 8,
    image: SpeedTypers,
    name: "SPEED TYPERS",
    description:
      "The Contest is a skill-based typing contest, in which eligible participants will compete by taking an online typing contest using an online typing website, ztype.pe which tests a Participant's speed and accuracy by calculating the word-per-minute typing speed ('WPM'). Once the game is completed, the website will calculate and indicate to the Participant what his or her final score and accuracy is which will be recorded. This score will be compared  against other Participants who have already played the game. At the end of the contest the Participants on the top of the leaderboard will be declared as winners.",
    rules: [
      "Players can have one trial round to understand the game.",
      "Each player can play the game only 3 times. ",
      "The best score out of three games will be considered as the final score.",
      "The player will be judged by the final score and accuracy after the game.",
      "EVALUATION CRITERIA:",
      "   The final score and accuracy of the player will be recorded and displayed on the leaderboard.",
      "   At the end of the event the players on the top of the leaderboards will be the winners.",
    ],
    prizes: [
      "Top 3 winners will get any one course out of c++, JAVA, Python, etc. With 100% Scholorship",
      "Goodies (top 10 )",
    ],
    team: "Individual",
    fees: "Free",
    contactInfo: ["Prasad Upasani : 7774040131"],
    location: "about to be fixed",
    date: "20 AND 21 FEBRUARY (10:00 AM to 5:00 PM)",
    note: [""],
    link: "https://docs.google.com/forms/d/1POXKCUgYFHqdmLj1XefekmTLfqBFF_cG3DHEDTGB-Pg/viewform?edit_requested=true#settings",
  },
  {
    id: 9,
    image: quiz,
    name: "Quiz",
    description:
      "In this contest at a time minimum 10 contestants can participate. Questions will be flashed on the screen one by one. There would be a buzzer system for the contestants. The person who hits the buzzer first will be given a chance to answer the displayed question. Maximum points to be awarded to the contestent if he/she gives correct answer in minimum time.",
    rules: [
      "This quiz is based on the buzzer system. The person who hits the buzzer first will be given first priority to answer the question.",
      "Complete individual event.",
      "EVALUATION CRITERIA:",
      "   At the end of the quiz contest the contestant with a high score will be declared as the winner.",
      "   Every Contestant should have a smart phone with constant internate connection.",
      "   Hotspot facility will provided by the organizer.",
    ],
    prizes: [
      "Top 3 winners will get any one course out of c++, JAVA, Python, etc. With 100% Scholorship",
    ],
    team: "5 contestants at a time",
    fees: "Free",
    contactInfo: [
      "Yash Gokakkar : 7499822665",
      "Omkar Shedge : 8308882756",
      "Sarvesh Zende : 9356552975",
    ],
    location: "Virtusa Lab (A Wing)",
    date: "20 AND 21 FEBRUARY (10:00 AM to 5:00 PM)",
    note: [""],
    link: "https://docs.google.com/forms/d/1POXKCUgYFHqdmLj1XefekmTLfqBFF_cG3DHEDTGB-Pg/viewform?edit_requested=true#settings",
  },
  {
    id: 10,
    image: HopSites,
    name: "Hop Sites",
    description: [
      "An activity in which players have to find out the clues by visiting different website by decoding the clue given at the beginning – just like treasure hunt participants will visit different websites & the one who decodes all the clues & complete the tasks will be considered as winner.",
      "Get ready to embark on a thrilling digital adventure! This online treasure hunt will take you on a journey through the web as you decode clues, complete challenges and discover hidden treasures, work your way through the puzzle and be crowned the ultimate champion! Don't miss out on this unforgettable experience, register now!",
    ],
    rules: [
      "Get ready to embark on a thrilling digital adventure! This online treasure hunt will take you on a journey through the web as you decode clues, complete challenges and discover hidden treasures, work your way through the puzzle and be crowned the ultimate champion!",
      "Disclaimer :",
      "The participant will receive a clue about: ",
      "The website to be visited.",
      "The element which is required to be found on the website.",
      "Participant is required to enter the element in the entry box for verification and get clue for further websites.",
      "Accessing sites not related to game will result in disqualification.",
    ],
    prizes: [
      "Each individual who successfully finds treasure in his first attempt will be rewarded with special GOODIES.",
    ],
    team: "Individual",
    fees: "20Rs. per person",
    contactInfo: ["Riyal Jain: 7470423278", "Vardhaman Begani: 7020676300"],
    location: "C wing Basement",
    date: "20 & 21 Feb full day",
    note: [
      "Final rules or any changes in rules will be informed to you before the event And umpire(event handler) decision will be final decision",
    ],
    link: "",
  },
  {
    id: 11,
    image: CodeBuddies,
    name: "CodeBuddies",
    description: [
      "The Partner Coding Competition is an exciting and unique challenge that combines the power of teamwork with the thrill of technology. Here, two coders will join forces to solve a coding problem in an innovative and interactive way. One partner will write a line of code and then pass the baton to the other partner, who will continue the solution by writing the next line. This pattern will repeat until the problem is solved, creating a seamless collaboration between the two partners.",
      "Whether you're a seasoned programmer or just starting out, this competition is a fantastic opportunity to improve your coding skills and build a stronger partnership with your coding buddy. As you work together to solve the problem, you'll learn from each other's strengths and weaknesses, developing new skills and expanding your knowledge of programming. This is a great way to challenge yourself and grow as a coder while having fun and building lasting memories.",
      "So, if you're looking for a fresh and exciting way to enhance your coding abilities, sign up for the Partner Coding Competition today! Whether you're competing for the first time or are an experienced coder, this is an opportunity you won't want to miss. Get ready to collaborate, learn, and grow with your coding buddy. The coding journey awaits!",
    ],
    rules: [
      "The Partner Coding Competition is an exciting and unique challenge that combines the power of teamwork with the thrill of technology. Here, two coders will join forces to solve a coding problem in an innovative and interactive way. One partner will write a line of code and then pass the baton to the other partner, who will continue the solution by writing the next line. This pattern will repeat until the problem is solved, creating a seamless collaboration between the two partners.",
      "Disclaimer :",
      "Two participants will take turns writing lines of code to solve a given problem statement.",
      "In stage 1 partners are allowed to discuss while coding.",
      "In stage 2 partners are not allowed to discuss while coding . Instead they will be given a set amount of time before starting to plan their approach.",
      "In stage 3 partners are not at all allowed to discuss while and before coding.",
      "Lines of code will be visible only to the person who is writing them and not to their partner.",
      "All stages will contain basic and easy problem statements.",
      "Successful execution of code results in a win.",
    ],
    prizes: [
      "Each team that successfully completes all the questions in their first attempt will be rewarded with special GOODIES",
    ],
    team: "2 members",
    fees: "20Rs. per team",
    contactInfo: ["Atharv Badwaik: 7888126711", "Nikita Thakur: 7021815065"],
    location: "C wing Basement",
    date: "20 & 21 Feb full day",
    note: [
      "Final rules or any changes in rules will be informed to you before the event And umpire(event handler) decision will be final decision",
    ],
    link: "/",
  },
  {
    id: 12,
    image: MaskedCoding,
    name: "Masked coding",
    description:
      "An event where a programmer is asked to code without looking at the screen. The programmer is given a problem to solve and has to write the code from memory, typing it out on a keyboard. The goal of this event is to test the programmer's ability to recall syntax and programming concepts, as well as their ability to think logically and problem-solve under pressure.",
    rules: [
      "Are you a coding ninja who can write lines of code without even looking at the screen ? If so, we have got the event for you. Join the competition where you will be given a blank screen anda problem statement to solve .With no visual cues, its all up to your mastery of the keyboard to execute your code and emerge as a coding champion.",
      "Disclaimer :",
      "Event consists of single participant who will write lines of code to solve a given problem statement.",
      "Participant will be provided with keyboard and blank screen. The screen will not display any text , participants will not be able to see what they are typing.",
      "Participant will win the event if their code successfully executes and solves the problem in given time limit.",
      "Participant must not communicate with any other person or use any external resources such as internet during the event.",
    ],
    prizes: [
      "Each individual who successfully completes all rounds of code questions will win goodies",
    ],
    team: "Individual",
    fees: "20Rs. per person",
    contactInfo: ["Deepal Mundhada: 9028935100", "Sukrut Rahane: 8446698770"],
    location: "C wing Basement",
    date: "20 & 21 Feb full day",
    note: [
      "Final rules or any changes in rules will be informed to you before the event And umpire(event handler) decision will be final decision",
    ],
    link: "/",
  },
  {
    id: 13,
    image: ShotOnQuiz,
    name: "Shot On Quiz",
    description:
      " A fun quizzes competition between teams where various categories of questions will be asked along with the punishment of drinking different kinds of shots.",
    rules: [
      "A batch of 4-5 teams will play at a time with each team consisting of 2-3 members.",
      "Total no of questions per batch - 15",
      "The first 10 questions will have options with time limit of 30s each and 5 points for each correct answer.",
      "The last 5 questions will not have options with time limit of 15s and 10 points for each correct answer",
      "Types of questions- General Science, Entertainment (fun task), dumb charades, etc.",
      "The team which presses the buzzer first will answer the question.",
      "If they answer it correctly the other teams will have to take a shot (chosen by chit system).",
      "If they answer it wrong then that team will take the shot(of the hosts choice).",
      "3 different shots will be there.",
      "Rewards- exciting rewards.",
      "Walk-in Registrations are allowed.",
    ],
    disqualification: [
      "If a team, after pressing the buzzer first, answers 3 questions wrong continuously.",
      "Prompting & Misbehaving",
    ],
    prizes: ["EXICITING PRIZES AND REWARDS"],
    team: "2-3 members",
    fees: "Free",
    contactInfo: ["Nayan : 9834020168", "Hrutik : 9881087152"],
    location: "A WING",
    date: "20th Feb, 10:00 am onwards.",
    note: [""],
    link: "https://docs.google.com/forms/d/e/1FAIpQLSeXHY3fe3259AmtmItE5u86mwj17aDg3H6KpPwq4yGa54AkUQ/viewform",
  },
  {
    id: 14,
    image: RoboRace,
    name: "ROBO Race",
    description:
      " Teams have to build a manually controlled bot with the aim to tackle maximum number of obstacles in minimum amount of time.",
    rules: [
      "BOT SPECIFICATIONS:",
      "   Maximum dimensions - 30 x 30 x 30 cm (L x B x H) at all times during runtime.",
      "   Maximum weight - 4 Kg",
      "   The bot is allowed to be powered at any supply voltage.",
      "   The controller can be wired or wireless, in case of wired, the wire must be placed at the back.",
      "ROBO RACE ARENA:",
      "   The exact arena will be displayed at the event.",
      "GAMEPLAY:",
      "   The bot should always cover entire track",
      "   Each participant will have three attempts. Best score will be selected as final score.",
      "   The exact pointing system and award for each obstacle will be clearly announced to the participants before their respective runs.",
      "RULES:",
      "   The bots will be checked for safety once before a run.",
      "   Only one operator is allowed to control the bot.",
      "   The operator cannot be changed during the runtime.",
      "   The organizers reserve the right to stop the run at any time where use of unfair means is observed.",
      "   The bot is not allowed to be powered by combustible, inflammable, explosive or any potentially dangerous processes.",
      "   After 2 warnings organizers have the power to deduct a suitable penalty.",
      "   Every operator must have unique bots and use of same bots by various contestants is prohibited.",
      "   The time measured by the organizers will be final and will be used for scoring of the teams.",
      "   In case of any disputes or discrepancies, the organizers decision will be final and binding.",
      "   Not complying to any of the above-mentioned rules will lead to disqualification of the team.",
    ],
    prizes: ["Winner: Rs. 6,000/-", "Runner Up: Rs. 4,000/-"],
    team: "Team ",
    fees: "Rs.199/- per Team.",
    contactInfo: ["Vedant Dashmukhe : 7447667935"],
    location: "Student Plaza, DYPCOE, Akurdi",
    date: "20 February 2023 (10 am Onwards)",
    note: [
      "Crossing every hurdle is compulsory",
      "The organizers reserve the rights to change the above format, if necessary.",
      "Teams can also register at the venue on the day of the event at least an hour prior to the event.",
    ],
    link: "https://docs.google.com/forms/d/e/1FAIpQLSd2Uc8Kyn0T-4F7McrCBRt40FSgMnyJEZc2L0YzJpZYgn16dg/viewform",
  },
  {
    id: 15,
    image: DraicPlayground,
    name: "DRAIC Playground",
    description: "Remaining",
    rules: ["NA"],
    prizes: ["NA"],
    team: "Individual",
    fees: "Free",
    contactInfo: ["Sumeet Jadhav : 9370580799"],
    location: "Student Plaza, DYPCOE, Akurdi",
    date: "20th and 21st February 2023 (10 am Onwards)",
    note: ["NA"],
    link: "",
    onSpot: "true",
  },
  {
    id: 16,
    image: RoboSoccer,
    name: "ROBO Soccer",
    description:
      "Two bots face off in an exhilarating match of football. Teams have to build a bot capable scoring goals and also defend against the opponent.",
    rules: [
      "BOT SPECIFICATIONS:",
      "   Maximum bot dimension - 30 x 30 x 30 cm (L x B x H)",
      "   Maximum weight - 5 Kg without controller",
      "   Power specification- maximum supply voltage of 12V (participants are informed to carry their own power supply).",
      "   Robots can be controlled in a wired or wireless manner.",
      "TEAM SPECIFICATION:",
      "   Each team may consist of maximum of 4 members.",
      "   Participants may be students of different colleges.",
      "   One participant can be a part of only one team.",
      "   Each team shall have their own unique bot.",
      "ARENA DIMENSIONS:",
      "   Arena Dimensions: 8 feet X 6 feet",
      "   Goal post Dimensions: 19.2 inches X 10 inches",
      "   Penalty arc chord width: 1.73 feet.",
      "   Centre Circle diameter: 9.6 inches",
      "   Ball Diameter: 3 inches",
      "   The arena will have a plywood base with a green colored carpet surface for the pitch.",
      "GAMEPLAY:",
      "   League matches of classic robo-soccer will be conducted based upon the numbers of entries received.",
      "   Organizers reserve the right to create draws as per their discretion.",
      "RULES:",
      "   The total duration of each match will be 4 minutes (i.e., each halves of 2 minutes). Half time of 30 seconds will be provided after first half in which team members can attend to their bots.",
      "   A standard tennis ball will be used for the match and each goal will be worth 10 points.",
      "   No harm must be done to arena by bots or members.",
      "   Decision made by judge or coordinator will be final.",
      "FOULS:",
      "   Kicking the ball out of the arena.",
      "   Damaging the opponent bot.",
      "   If any team member touches any bot without the referee's /event managers permission, it is considered a  foul.",
      "   Damaging the arena.",
      "   Any other offensive or aggressive behavior will be considered as a foul such as Bot going in opponent’s penalty arc.",
      "SCORING:",
      "   10 points for every goal.",
      "   -5 points for every penalty.",
      "   In case of a tie, team with less penalties wins.",
      "   Each team can have maximum of three hand-touches, there after negative of 2 points will be deducted for each hand-touch.",
      "   The robot at all times should be a singular piece.",
      "   Any type of intentional damage to the other robot by any means like spikes, weapon, etc. will NOT be entertained, the team doing so will be disqualified.",
      "   Any damage to the arena would result in immediate disqualification of the team.",
      "   Any and all decisions taken by the coordinator will be final and not up for discussion.",
      "   Failure in abiding to any of the given rules will lead to immediate disqualification of the team.",
    ],
    prizes: ["Winner: Rs. 6,000/-", "Runner Up: Rs. 4,000/-"],
    team: "Team ",
    fees: "Rs.199/- per Team.",
    contactInfo: ["Sanchit Kasar : 7773909160"],
    location: "Student Plaza, DYPCOE, Akurdi",
    date: "20 February 2023 (10 am Onwards)",
    note: [
      "All participants must carry their valid college id-cards and the registration receipt.",
      "The decision of organizers will be final in all respects during the competition and participants must abide to the same.",
      "Any kind of misbehavior with organizers or with other participants will lead to disqualification of entire team.",
      "Organizers reserve the rights for any change in the rulebook, if required.",
      "Organizers reserve the rights to make changes to the field design at any time without prior notification.",
      "Teams can also register at the venue on the day of the event at least an hour prior to the event.",
    ],
    link: "https://docs.google.com/forms/d/e/1FAIpQLSd2Uc8Kyn0T-4F7McrCBRt40FSgMnyJEZc2L0YzJpZYgn16dg/viewform",
  },
  {
    id: 17,
    image: BotBusters,
    name: "ROBO Buster",
    description:
      " ENTC department Presents ROBO BURSTER This game is all about team war between 4 people which will be in 2v2 form. In this event we have to burst all the balloon/lives of the opponent’s bot before the given time limit, the team which bursts all the balloons in minimum time will be the winner of the event. It’s more like TDM (Team Death Match).Step into a world of excitement with Robots! Go wild as you race against time and pop balloons, dodge needles and beat the clock to become the ultimate BURSTER. Get ready and buckle up your seats",
    rules: [
      "OBJECTIVE: To burst maximum number of balloons in minimum  amount of time.",
      "COMPOSITION OF TEAM:  2 players per team.",
      "MATERIALS: Everything will be provided by us.",
      "You can’t touch the bots, all the actions related to bots will be done by remote control only, no participants are allowed to touch the bots.",
      "If the bots get entangled and if there is no way out, you can try your level best by remote control, neither participants nor referee are allowed to touch the bot.",
      "Talking about points",
      "You will get 3 lives that are 3 balloons, when you burst opponent’s balloons, points will be allocated to your team accordingly.",
      "Winners will be considered when they burst maximum number of balloons in the minimum time, the referee will keep track of points.",
      "You will be allotted 5 mins for match and your points will be allocated according to 5 min timestamp",
      "If there is a tie, then the team who busted the very first balloon (like the overall first) will win that match",
      "There is friendly fire also, if you burst your teammate’s balloon the point will be allocated to your opponents so watch out where you attack!",
      "Talking about winning prizes",
      "Top 3 teams with minimum time and maximum points will be given amazing goodies",
    ],
    prizes: ["Goodies depending upon no of registration"],
    team: "2 Members Team",
    fees: "50 Rs. per team (If you do not have teammates we will pair you up, charges for solo registration will be Rs.30.)",
    contactInfo: ["Ayush Nagpure : 9325864885", "Ajinkya Jawale : 8767027701"],
    location: "Lawn in front of C wing",
    date: "20th Feb (Full Day)",
    note: [""],
    link: "https://docs.google.com/forms/d/e/1FAIpQLSd3f8HXzhh4EvjNh2S2NAo4o5GRotXv3n4038NusyvUmsQFYw/viewform",
  },
  {
    id: 18,
    image: CadCompetiton,
    name: "CAD Competition",
    description:
      " CAD Competition is an event where students interested in designing and modeling can show their skills/talent and win exciting prizes. CAD Competition is not limited by specific software use, any designing software, be it Solidworks, Catia, AutoCAD, etc. can be used by participants. Participants can bring their own laptop/system consisting of any design software or else system will be provided to them by organizers",
    rules: [
      "Make design from scratch",
      "No use of the Internet while designing.",
      "2 hours duration for designing.",
    ],
    prizes: ["1st: Mivi Duopods", "2nd: Laptop Bag"],
    team: "2 Members Team",
    fees: "100 Rs",
    contactInfo: [
      "Shambhuraje Ghorpade : 9765442079",
      "Ajinkya Suryavanshi : 7387958706",
    ],
    location: "CAD/CAM Lab",
    date: "21/02/2023 (10:00 A.M to 1:00 P.M)",
    note: [""],
    link: "https://docs.google.com/forms/d/e/1FAIpQLSdoBbbc_iWaqnNIhqyKIGMeQP5JWhjXmtUTaDtxBsUmts_PZg/viewform",
  },
  {
    id: 19,
    image: TremblingTower,
    name: "TREMBLING TOWER",
    description:
      "Civil Engineering Student Association Presents TREMBLING TOWER A tower making competition In this event a tower is to be built with the help of Popsicle sticks. The Material required and Dimensions for making tower will be provided. It is a game of skill + mind. So let’s make a unique structure. Do join us and win exciting prizes.",
    rules: [
      "OBJECTIVE: To design and build a tower, which will bear the maximum load by using only popsicle sticks and glue.",
      "MATERIALS:",
      "   Materials used for construction of towers are restricted to following:",
      "     Popsicle sticks",
      "     Glue",
      "   Maximum number of sticks: 100 sticks",
      "CONSTRUCTION SPECIFICATIONS:",
      "   Height of tower: 30cm",
      "   Cross sectional dimensions: 10cm10cm",
      "   Dimensional error of  1 cm will be considered. [Towers with error more than 1cm will be disqualified]",
      "   Participants should make top platform by using popsicle sticks as load will be given from top platform.",
      "JUDGING CRITERIA:",
      "   Dimensions of the tower",
      "   Strength to self-weight ratio i.e. [Load carried by tower/self-weight]",
      "INSTRUCTIONS:",
      "   Use of materials other than which are provided by us is strictly prohibited.",
      "   Participants should make top platform by using popsicle sticks as load will be given from top platform.",
      "   If the dimensional error exceeds 1cm model will be disqualified.",
    ],
    prizes: ["Winner:3000", "Runner up:2000"],
    team: "2 to 4 members per team.",
    fees: "Rs.200/ Team",
    contactInfo: [
      "Shrikrushna Gawade : 9420103663",
      "Anurag Shendekar : 7588923120",
    ],
    location: "Lawn in front of C wing",
    date: "Tower making: 20 Feb 2023, 10 AM onwards, Tower testing: 21 Feb 2023, 10 AM onwards",
    note: [
      "No other material may be used for construction of tower. Tower may not be painted.",
    ],
    link: "https://docs.google.com/forms/d/e/1FAIpQLSf37Z0h9Rya9TXifYPuuQU4QPs-LglQHpKIc3Ve4uJ8ytbpdg/viewform",
  },
  {
    id: 20,
    image: Blogathon,
    name: "BLOGATHON",
    description:
      "Iasc Blogathon Hola amigos!🤩 Our team IASC DYPCOE in collaboration with SAMBHAV and ABHIVYAKTI ✨ is back with another exciting event! This is our first ever Blog-a-thon💬 with exciting prizes 🏆 for the winners! You have to write ✍️ a blog on the Topic:- Your Journey falling in love with a tech 👩‍💻 domain The Deadline for submission is 21st December 5:00 pm. Along with prizes🏆 the top 3 submissions would also get a chance to be featured in our college magazine via team Abhivyakti 💫 So what are you waiting for?!🤩 Get your creative minds running 🌟 We are eager to read about your Journey!❤️",
    rules: [
      "Plagiarized or AI generated content is strictly not allowed. If found, we will disqualify it immediately.",
      "The word limit of the blog should be between 800-1200 words.",
      "Along with content quality your blog would also be judged on how well it is promoted i.e number of likes or votes it receives.",
      "The Blog can be published on any blogging website of your choice eg-linkedin,twitter,medium,hashnode etc. Try to use a popular website so it will be easier to promote.",
      "The Blog is expected to be descriptive i.e focusing on why you got into a specific tech domain,how you got interested and the challenges you faced while exploring it. We don’t expect you to go into the technicalities of the domain",
      "You are expected to use the following hashtags compulsorily while posting the blog:- #iasc #iascdypcoe #sambhav #blog-athon and can add additional hashtags of your choice.",
      "EVALUATION CRITERIA:",
      "   The Blog would be given a score out of 50,where 35 marks are for the quality of content and the rest 15 marks are for how well it is promoted.",
      "   Total score=Content(35) + No.of votes(converted out of 15)=50",
    ],
    prizes: [
      "Top 3 winners will get any one course out of c++, JAVA, Python, etc. With 100% Scholorship",
      "winners will get there blog published in college magazine",
    ],
    team: "Individual",
    fees: "Free",
    contactInfo: [
      "Varsha Kotipalli : 9561387199",
      "Aashavi Kothari : 7738734644",
    ],
    location: "Online",
    date: "13th AND 21 FEBRUARY (submission link will close at 5:00 PM)",
    note: [""],
    link: "https://docs.google.com/forms/d/e/1FAIpQLSfT4q9dRseQqkbgxfOIZ9CUXGgmtHMZHCLR9IucOMeLuiv_Pg/viewform",
  },
  {
    id: 21,
    image: ReadandType,
    name: "READ AND TYPE",
    description:
      "Read and Type is a two-player game that requires quick reflexes and strong teamwork. The game is simple in concept but challenging in execution. One player reads a text passage while the other player types it out as accurately as possible. The catch is that they only have six minutes to complete the task. The faster and more accurately the players work, the more points they can score. The reader must be able to read quickly and clearly while the typist must be able to type with speed and accuracy. Communication is key, as the reader must be able to alert the typist to any errors or mistakes in the text.",
    rules: [
      "This event will be a pair event.",
      "You could come with your friend or get a partner on the spot with the available contestants.",
      "Each pair will be given books where one person will read the given text for 3 minutes and the other will type it as fast he/she can.",
      "Then for the next 3 minutes they will switch sides and do the same.",
      "Each team has to attempt to type down Maximum number of words in the given time with high accuracy.",
      "EVALUATION CRITERIA:",
      "   The text typed by both members will be evaluated using an AI tool.",
      "   The team with the highest accuracy and number of words will win.",
      "Total points awarded are 100",
      "For number of words 50 points and for accuracy of words 50 points.",
      "For typing of 200+ words you get 50 points and for every wrong spelling 2 points are deducted.",
    ],
    prizes: [
      "The winners from Day 1 and Day 2 both will be evaluated and a Leaderboard will be made the Top 10 teams will be Winners and will win free Membership From Books and Beyond ",
      "Top 3 winners will get any one course out of c++, JAVA, Python, etc. With 100% Scholorship",
    ],
    team: "Team of 2",
    fees: "Free",
    contactInfo: [
      "Sayam Palrecha : 9370091963",
      "Yash Gokakkar : 7499822665",
      "Omkar Shedge : 8308882756",
      "Rohita : 9945798364",
    ],
    location: "about to be fixed",
    date: "20 AND 21 FEBRUARY (10:00 AM to 5:00 PM)",
    note: [
      "This fast-paced game is for those who want to put their teamwork and typing skills to the test.",
    ],
    link: "https://docs.google.com/forms/d/1POXKCUgYFHqdmLj1XefekmTLfqBFF_cG3DHEDTGB-Pg/viewform?edit_requested=true#settings",
  },
  {
    id: 22,
    image: Hackathon,
    name: "7BITS",
    description: [
      "The upcoming contest is a great opportunity for computer science enthusiasts to test their skills in Data Structure and Algorithm (DSA) problems. The contest will feature a total of 7 DSA problems, with 2 problems being easy, 4 medium-level problems, and 1 challenging problem. Participants will be able to solve the problems in a time frame of 2 hours and the team size should consist of a minimum of 2 students and a maximum of 4 students.",
      "To ensure a smooth and seamless experience, each team will be provided with 2 PCs. Teams are also welcome to bring their own laptops if they prefer. The top 3 teams will be rewarded with a 3-month subscription to TLE ELIMINATORS, a valuable resource for anyone looking to enhance their DSA skills. In addition, the top 10 teams will receive stickers as a token of appreciation for their participation.",
      "This contest is a fantastic opportunity for individuals or teams to showcase their DSA knowledge and skills. So gear up, bring your best problem-solving skills, and get ready to participate in this exciting contest!",
    ],
    rules: [
      "Eligibility: The contest is open for every registered participant.",
      "Contest Format: The contest will consist of a set of 7 DSA problems, with 2 problems being easy, 4 medium-level problems, and 1 challenging problem, all to be solved in the time frame of 2 hours.",
      "Programming Languages: Participants may use any programming language that is supported by the Hackerrank.",
      "Plagiarism: Any instance of plagiarism will result in immediate disqualification.",
      "Code of Conduct: All participants are expected to follow a code of conduct that includes respecting fellow participants and avoiding any behavior that might be considered offensive or disrespectful.",
      "Prohibited Materials: Participants are not allowed to bring any electronic devices, including mobile phones, into the contest area.",
      "Tiebreakers: In the event of a tie, the tiebreaker will be based on the time of submission for the last correct answer.",
      "Organizing Committee: The organizing committee reserves the right to disqualify any participant who violates the rules and regulations of the contest.",
      "Rule Changes: The organizing committee reserves the right to make changes to the rules and regulations of the contest at any time, and participants will be notified of any changes in advance.",
    ],
    prizes: ["EXICITING PRIZES AND REWARDS"],
    team: "2-4 Students in a team",
    fees: " Free",
    contactInfo: ["Aryan Jangid : 7665313444"],
    location: "AI & DS lab",
    date: "22th Feb 2022",
    note: [""],
    link: "https://docs.google.com/forms/d/1u1mXeqcf-VqEXdsasT8xlhta5CO3zw6y8MZbYkfDTx8/viewform?edit_requested=true",
  },
  {
    id: 23,
    image: GamingZone,
    name: "GAMING ARENA",
    description:
      "An interactive gaming zone consisting of games like Valorant and Fall Guys. Valorant will be a time game, where in each team will consist 5 players; 2 teams competing against each other Whereas Fall Guys, it will be an individual game.",
    rules: [
      "Valorant: ",
      "   Every team must contain 3-5 players.",
      "   If teams want then they can play online but at least their 2 members must be present on the venue.",
      "   Game will be executed in Swiftplay model",
      "   Only pre registrations are allowed, no walk in registrations will be entertained.",
      "   Every team will have to bring their own laptops",
      "   If team's want, then they can bring their own headphones, no headphones will be provided by the management. ",
      "   Teams will be divided into slots!",
      "   Top Teams of each slots will get advanced to next levels, accordingly winners will be decided at the end of day.",
      "   Team must be present 10 minutes before the slot time.",
      "   Team which will be late will not be entertained further! (Will get disqualified)",
      "Fall guys: ",
      "   This will be a single player game.",
      "   Every player must bring their own laptops",
      "   At a time, a batch of 9-10 players will be playing in a private lobby consisting of various maps, wherein players will advance accordingly. ",
      "   Hence every batch will have its winner.",
      "   The winner will be getting some exciting rewards.",
      "   On spot registrations are allowed but priority will be given to pre-registration players.",
    ],
    prizes: ["EXICITING PRIZES AND REWARDS"],
    team: "valorant: 3-5 players , Fall guys: Individual players",
    fees: "Valorant: ₹100/Team, Fall guys: ₹30/Team",
    contactInfo: ["Nikhil : 91236 81089", "Abhishek : 96070 52928"],
    location: "A wing (FPL lab)",
    date: "21st Feb 2023 (11 onwards)",
    note: [""],
    link: "https://docs.google.com/forms/d/e/1FAIpQLSf6i9W6BTw4ff8a_rqLpeb2NRnsYdFjx7DKqqzbXlEGoejqaA/viewform",
  },
  // {
  //   id: 24,
  //   image: KeynoteSession,
  //   name: "KEYNOTE SESSION",
  //   description: "",
  //   rules: [""],
  //   prizes: [""],
  //   team: "",
  //   fees: "",
  //   contactInfo: [""],
  //   location: "",
  //   date: "",
  //   note: [""],
  //   link: "",
  // },
  {
    id: 24,
    image: SupercarShow,
    name: "SUPERCAR SHOW",
    description:
      "A car show is where car enthusiasts gather to showcase and admire various cars, including vintage, classic, modern, JDM, and tuned models. JDM cars are Japanese domestic market vehicles that are highly sought after for their performance and style. Car shows offer a chance for owners to display their prized possessions and for the public to appreciate the beauty and innovation of automobiles.",
    rules: ["NA"],
    prizes: ["NA"],
    team: "Individual",
    fees: "Free",
    contactInfo: [""],
    location: "D. Y. Patil Education Complex, Akurdi",
    date: "20th Feb",
    note: [""],
    link: "",
  },
  {
    id: 25,
    image: SpaceExpo,
    name: "SPACE TECH",
    description:
      "Space expo will be a presentation of highly appreciated space models from all space Organizations. n this event we will showcase models of launch vehicles like GSLV,  PSLV from ISRO. Likewise the high end missions like Mars orbiter mission, Chandrayaan 2, ASTROSAT will be detailed and showcased by multiple models and informative banners. Major satellites like Parker Solar Probe, Hubble Telescope, Astrosat, Sputnik will be discussed and their models will be showcased.",
    rules: ["NA"],
    prizes: ["NA"],
    team: "Individual",
    fees: "Free",
    contactInfo: [
      "Paras Dhongade  : 7798647910",
      "Shriraksha SN   : 8767997653",
    ],
    location: "Center Lawn",
    date: "20th and 21st Feb (10:00am onwards)",
    note: [
      "Quiz will be conducted regarding space technology, few lucky winners will get exciting goodies and gifts",
    ],
    link: "",
    onSpot: "true",
  },
  // {
  //   id: 27,
  //   image: web3,
  //   name: "Introduction to Web3",
  //   description: [
  //     "We GDSC DYPCOE are going to conduct our first ever event in Web3 domain “Introduction to Web3” at our pristine institute DYPCOE. Web3 (also known as Web 3.0]) is an idea for a new iteration of the World Wide Web which incorporates concepts such as decentralization, blockchain technologies, and token-based economics. The most worth noting difference between web3 and web2 is decentralization and the way it has been achieved.",
  //     "Key things that will be achieved in the event : ",
  //     "Getting familiarized with Web3",
  //     "Presentation and introduction of domain",
  //     "Seminar,",
  //     "Providing roadmaps for web3 technologies, ",
  //     "along with PPT we will show some videos ",
  //     "we will also have interaction with kids",
  //     "Networking,",
  //     "Quiz Competitions",
  //     "Overall it will totally a fun and more specifically an informative event. Students will get a chance to resolve their doubts personally with the domain expert. ",
  //   ],
  //   rules: ["NA"],
  //   prizes: ["NA"],
  //   team: "Individual",
  //   fees: "Free",
  //   contactInfo: ["Ashutosh Shimpi : 8087572655", "Nikhil Shinde : 8007243335"],
  //   location: "Dyanprasad Sabhagruha, DYP Campus",
  //   date: "20th Feb, 2022",
  //   note: [""],
  //   link: "",
  // }, 
  */}
];
